<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Payment Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="payment_date_from"/> ~ <CustomDatePicker v-model="payment_date_to"/></span>

				<!-- <span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" /> </span> -->

				<span class="int_type mgr_5">
					<input type="text" v-model.trim="reason" placeholder="Enter Reason" autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<!-- <div style="height:780px;"> -->

		<div class="fixed-table-container" style="height:720px;">
			<div class="table-wrapper">
				<table class="list_tbl tbl_pointer">
					<thead>
						<tr>
							<th width="20px;"></th>
							<th width="120px;"><div class="th-text">Vendor Code</div></th>
							<th><div class="th-text">Name</div></th>
							<th width="120px;"><div class="th-text">PO Date</div></th>
							<th width="120px;"><div class="th-text">PO No</div></th>

							<th width="120px;"><div class="th-text">Payment Date</div></th>

							<th width="120px;"><div class="th-text">Payment Term</div></th>
							<th width="120px;"><div class="th-text">PO Amt.</div></th>
							<th width="120px;"><div class="th-text">PO Pay Amt.</div></th>

							<th width="120px;"><div class="th-text">Pay Amt.</div></th>
							<th width="150px;"><div class="th-text">Check No(s)</div></th>
							<th width="50px;"><div class="th-text">R</div></th>
							<th width="240px;"><div class="th-text">Reverse Reason</div></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(payment, i) in payments" v-bind:key="i" v-bind:class="{ on: payment.payment_no == selectedPayment.payment_no }" @click="selectRow(payment)">
							<td class="al_center" :rowspan="payment.po_count" v-if="!i ? true : payments[i - 1].payment_no == payments[i].payment_no ? '' : true">
								<input type="radio" :disabled="payment.reverse_yn == 'Y'" v-model="selectedPayment.payment_no" :value="payment.payment_no" />
							</td>
							<td class="al_left">
								<a href="javascript:;" @click="gotoApHistory(payment.vendor_code, payment.vendor_name)">{{ payment.vendor_code }}</a>
							</td>
							<td class="al_left truncate">{{ payment.vendor_name }}</td>
							<td class="al_left">{{ payment.po_date }}</td>
							<td class="al_left">{{ payment.po_dn }}</td>

							<td class="al_left" :rowspan="payment.po_count" v-if="!i ? true : payments[i - 1].payment_no == payments[i].payment_no ? '' : true">
								{{ payment.payment_date }}
							</td>

							<td class="al_left">{{ payment.payment_term_name }}</td>

							<td class="al_right">{{ payment.po_amount | toCurrency }}</td>
							<td class="al_right">{{ payment.paid_amount | toCurrency }}</td>

							<td class="al_right" :rowspan="payment.po_count" v-if="!i ? true : payments[i - 1].payment_no == payments[i].payment_no ? '' : true">
								{{ payment.total_amount | toCurrency }}
							</td>

							<td class="al_left" :rowspan="payment.po_count" v-if="!i ? true : payments[i - 1].payment_no == payments[i].payment_no ? '' : true">{{ payment.payment_info }}</td>
							<td class="al_center" :rowspan="payment.po_count" v-if="!i ? true : payments[i - 1].payment_no == payments[i].payment_no ? '' : true">
								<span :style="payment.reverse_yn == 'Y' ? 'font-weight:bold;color:red;' : ''">{{ payment.reverse_yn }}</span>
							</td>
							<td class="al_left" :rowspan="payment.po_count" v-if="!i ? true : payments[i - 1].payment_no == payments[i].payment_no ? '' : true">
								{{ payment.reverse_reason }}
							</td>
						</tr>

						<tr>
							<td colspan="7" class="al_right"><font color="red">Listed Total</font></td>

							<td class="al_right">
								<font color="red">{{ po_amount_sum | toCurrency }}</font>
							</td>
							<td class="al_right">
								<font color="red">{{ paid_amount_sum | toCurrency }}</font>
							</td>
							<td class="al_right">
								<font color="red">{{ paid_amount_sum | toCurrency }}</font>
							</td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div style="text-align:right;padding-right:10px;">Total PO Count : {{ list_count | commaSeparated }} (Max {{ max_count }} payments)</div>

		<div class="bottom_bt_box" style="padding-top:10px;">
			<ul>
				<a v-if="modifiable" href="javascript:;" class="gray_bt" @click="reverse()">Reverse Process</a>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Confirm</template>
			<template slot="body">
				<div style="width:400px; height:150px;">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:120px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Select Reason</th>
								<td>
									<select class="tbl_select full_int" v-model="new_reason">
										<option :value="null">Select or Write yourself</option>
										<option value="Accident ">Accident</option>
										<option value="Change a method type ">Change a method type</option>
									</select>
								</td>
							</tr>
							<tr>
								<th>Write Reason</th>
								<td><input type="text" v-model.trim="new_reason_input" :disabled="new_reason" class="tbl_int full_int" @focus="$event.target.select()" /></td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="reverseConfirm()" class="search_bt mgr_15">OK</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectPaymentReverseList, apiReversePayment } from '@/api/payment/index.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
// import CodeSelect from '@/components/common/CodeSelect';
//import PartnerSelect from '@/components/common/PartnerSelect';
import { daysAgo, today } from '@/utils/date.js';
// import ReceiptPopup from '@/components/common/ReceiptPopup';
import Modal from '@/components/common/Modal';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			backUri: '/',

			payment_date_from: daysAgo(180),
			payment_date_to: today(),
			//receipt_date_from: null,
			//receipt_date_to: null,

			allSelected: false,

			payments: [],
			selectedPayment: {},

			//bill_to_code: null,
			reason: null,

			list_count: null,
			max_count: 200,

			modalName: '',
			showModal: false,

			new_reason: null,
			new_reason_input: null,

			default_ago_days: 180,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		po_amount_sum() {
			var po_amount_sum = 0;
			this.payments.forEach(r => {
				po_amount_sum += r.po_amount;
			});
			return po_amount_sum;
		},
		paid_amount_sum() {
			var paid_amount_sum = 0;
			this.payments.forEach(r => {
				paid_amount_sum += r.paid_amount;
			});
			return paid_amount_sum;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		// Paging,
		// CodeSelect,
		//PartnerSelect,
		// ReceiptPopup,
		Modal,
	},
	methods: {
		calRowSpanCount(index, invoice_count) {
			console.log(index);
			//return index + invoice_count > this.max_count ? Math.max(index + invoice_count - this.max_count - 1, 1) : invoice_count;
			return invoice_count;
		},
		// gotoArHistory(partner_code, partner_name) {
		// 	this.$router.push({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '2' } });
		// },
		// setPartner(partner) {
		// 	this.bill_to_code = partner.code;
		// 	this.search();
		// },
		selectRow(payment) {
			this.selectedPayment = payment;
		},
		reverse() {
			if (this.selectedPayment.reverse_yn == 'Y') {
				this.$toast.error('Already Reversed Payment');
				return;
			}
			if (!this.selectedPayment.payment_no) {
				this.$toast.error('Nothing to process');
				return;
			}

			this.new_reason = null;
			this.new_reason_input = null;
			this.showModal = true;

			// this.$alertify.promptWithTitle('Confirm', 'Are you sure to reverse the receipt? Please enter the reason.', '', (evt, value) => {
			// 	this.reverseConfirm(value);
			// });
		},
		closeModal() {
			this.showModal = false;
		},
		//async reverseConfirm(reason) {
		async reverseConfirm() {
			var reason;
			if (this.new_reason) reason = this.new_reason;
			else reason = this.new_reason_input;
			//console.log(reason);
			this.showModal = false;

			const { data } = await apiReversePayment({
				payment_no: this.selectedPayment.payment_no,
				reason: reason,
			});

			if (data.result) {
				this.$toast.success('Payment reversed successfully');
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		reset() {
			this.payment_date_from = daysAgo(this.default_ago_days);
			this.payment_date_to = today();

			//this.bill_to_code = null;
			this.keyword = null;
		},
		search() {
			this.selectPayments();
		},
		async selectPayments() {
			this.selectedPayment = {};

			const { data } = await apiSelectPaymentReverseList({
				payment_date_from: this.payment_date_from,
				payment_date_to: this.payment_date_to,
				vendor_code: this.vendor_code,
				reason: this.reason,

				max_count: this.max_count,
			});
			this.payments = data.paymentList;
			this.list_count = this.payments.length;
		},
		// gotoPartner(code) {
		// 	this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
		// },
		async init() {
			await this.selectPayments();
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 4);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_ap_reverse');
		this.$store.commit('setSubTitle', 'AP -> Payment Reverse');

		this.default_ago_days = 180;

		this.payment_date_from = daysAgo(this.default_ago_days);

		this.init();
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
